export default __webpack_public_path__ + "static/media/hht2_storybook_16.16e13c1c.png";